// frontend/src/components/activities/ActivityLog.js

import React from "react";
import { formatInUserTimezone } from "../../utils/timezone";

function ActivityLog({ activities }) {
  if (!activities || activities.length === 0) {
    return <p className="text-muted">No activities recorded</p>;
  }

  // Sort activities by date (newest first)
  const sortedActivities = [...activities].sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return formatInUserTimezone(date);
    } catch {
      return date;
    }
  };

  return (
    <div className="activity-log">
      {sortedActivities.map((activity, index) => (
        <div className="activity-item" key={activity.id || index}>
          <div className="activity-icon">
            <i className={`fas fa-${getActivityIcon(activity.type)}`}></i>
          </div>
          <div className="activity-content">
            <div className="activity-header">
              <span className="activity-type">{activity.type}</span>
              <span className="activity-date">
                {formatDate(activity.scheduled_date)}
              </span>
            </div>
            <p className="activity-description">
              {/* REMOVED INLINE STYLE - Using CSS class only */}
              <span className="link-btn">{activity.company || "N/A"}</span>
              {" - "}
              {activity.description || "Activity recorded"}
            </p>
            {activity.created_by_name && (
              <span className="activity-user">
                by {activity.created_by_name}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function getActivityIcon(type) {
  const icons = {
    "Lead Created": "plus-circle",
    "Status Changed": "exchange-alt",
    "Lead Status Changed": "exchange-alt",
    "Demo Booked": "calendar-check",
    "Demo Rescheduled": "calendar-alt",
    "Demo Completed": "check-circle",
    "Demo Cancelled": "calendar-times",
    "Phone Call": "phone",
    Email: "envelope",
    Meeting: "handshake",
    "Follow-up": "clock",
    "Note Added": "sticky-note",
    "Note Updated": "sticky-note",
    "Contact Added": "user-plus",
    "Lead Updated": "edit",
    "Documents Uploaded": "file-upload",
    "Document Deleted": "file-alt",
    "Document Updated": "sync",
  };
  return icons[type] || "circle";
}

export default ActivityLog;
